import { ComponentType, ReactNode } from "react";
import Select, { components, DropdownIndicatorProps, GroupBase } from "react-select";
import { InputProps } from "react-select/dist/declarations/src/components/Input";

import Icon from "@components/text/Icon";
import BodyCopy from "@components/typography/BodyCopy";
import { inputSelectStyles } from "@utils/formUtils";

type Option = {
  image?: ReactNode;
  isFixed: boolean;
  label: string;
  value: string;
};

type Props = {
  className?: string;
  noOptionsLabel: string;
  onChange: (values: string[]) => void;
  options: Option[];
  placeholder: string;
  values: string[];
};

const DropdownIndicator: ComponentType<DropdownIndicatorProps<Option, boolean, GroupBase<Option>>> = props => (
  <components.DropdownIndicator {...props}>
    <Icon color="primary" icon="add" />
  </components.DropdownIndicator>
);

const Input: ComponentType<InputProps<Option, boolean, GroupBase<Option>>> = props => (
  <components.Input {...props} data-lpignore="true" />
);

const InputSelect = ({ className, noOptionsLabel, onChange, options, placeholder, values }: Props) => {
  const formatOptionLabel = ({ image, label }: Option) => (
    <div className="flex items-center gap-sm">
      {image}
      <div>{label}</div>
    </div>
  );

  return (
    <div className={className}>
      <Select
        autoFocus
        classNamePrefix="react-select"
        components={{ DropdownIndicator, Input }}
        defaultMenuIsOpen
        formatOptionLabel={formatOptionLabel}
        isMulti
        isSearchable
        menuPortalTarget={document.body}
        noOptionsMessage={() => <BodyCopy color="gray-500">{noOptionsLabel}</BodyCopy>}
        onChange={option => {
          const properlyTypedOption = option as unknown as Option[];
          onChange(properlyTypedOption.map(option => option.value));
        }}
        openMenuOnFocus
        options={options}
        placeholder={placeholder}
        styles={inputSelectStyles<Option>()}
        value={options.filter(option => values.includes(option.value))}
      />
    </div>
  );
};

export default InputSelect;
